import { gql } from 'graphql-request';

export const PENDING_FIELDS = gql`
  fragment PendingFields on PendingDto {
    pendingId
    type
    status
    metadata
    context
    createdAt
    updatedAt
  }
`;

export const getPendings = gql`
  ${PENDING_FIELDS}
  query getPendings($statuses: [String]) {
    getPendings(statuses: $statuses) {
      ...PendingFields
    }
  }
`;

export const getPendingById = gql`
  ${PENDING_FIELDS}
  query getPendingById($id: String!) {
    getPendingById(id: $id) {
      ...PendingFields
    }
  }
`;

export const updatePendingStatus = gql`
  ${PENDING_FIELDS}
  mutation updatePendingStatus($pendingId: String!, $status: String!) {
    updatePendingStatus(pendingId: $pendingId, status: $status) {
      ...PendingFields
    }
  }
`;

const PendingGraphQL = {
  queries: {
    getPendings,
    getPendingById,
  },
  mutations: {
    updatePendingStatus,
  },
};

export default PendingGraphQL;
